import NextHead from 'next/head'
import { useTranslation } from 'react-i18next'
import { Apollo } from 'components/Head/Apollo'
import { Artesian } from 'components/Head/Artesian'
import { Meta } from './Meta'

interface HeadProps {
  title?: string
  description?: string
  keywords?: string
  socialDescription?: string
}

export const Head = (props: HeadProps) => {
  const { t } = useTranslation('@mc/next')

  const title = props.title ?? t('forBusiness.meta.title')
  const description = props.description ?? t('forBusiness.meta.description')
  const keywords = props.keywords ?? t('forBusiness.meta.keywords')
  const socialDescription =
    props.socialDescription ?? t('forBusiness.meta.socialDescription')

  return (
    <>
      <NextHead>
        <title>{title}</title>
      </NextHead>
      <Meta
        title={title}
        description={description}
        keywords={keywords}
        socialDescription={socialDescription}
      />
      <Artesian />
      <Apollo />
    </>
  )
}
